/**
 * ShopTof — Quick Add to Cart (product cards)
 * Uses Shopify's /cart/add.js AJAX API.
 * Works for single-variant products only.
 * Multi-variant products redirect to the product page.
 */
(function () {
  'use strict';

  function updateCartCount(count) {
    var badges = document.querySelectorAll('.st-cart-count');
    badges.forEach(function (b) {
      b.textContent = count;
      b.style.display = count > 0 ? '' : 'none';
    });
    var drawerCount = document.getElementById('st-cart-count-drawer');
    if (drawerCount) drawerCount.textContent = '(' + count + ')';
  }

  function openCartDrawer() {
    var drawer  = document.getElementById('st-cart-drawer');
    var overlay = document.getElementById('st-cart-overlay');
    if (drawer)  drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
  }

  function addToCart(variantId, qty, btn) {
    btn.classList.add('st-adding');
    var originalText = btn.textContent;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status && data.status !== 200) {
        btn.textContent = data.description || 'Error';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.classList.remove('st-adding');
        }, 2200);
        return;
      }
      btn.classList.remove('st-adding');
      btn.classList.add('st-added');
      btn.textContent = '✓ Added!';
      // Refresh cart count
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          openCartDrawer();
        });
      setTimeout(function () {
        btn.textContent = originalText;
        btn.classList.remove('st-added');
      }, 2200);
    })
    .catch(function () {
      btn.classList.remove('st-adding');
      btn.textContent = 'Try Again';
      setTimeout(function () { btn.textContent = originalText; }, 2200);
    });
  }

  // Delegate clicks on all .st-atc-btn buttons (product cards only, NOT the page ATC button)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.st-atc-btn') || e.target.closest('.ali-atc');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    addToCart(variantId, 1, btn);
  });

  // Scroll reveal (in case section doesn't include its own)
  (function () {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.reveal').forEach(function (el) { obs.observe(el); });
  })();

})();



/* ShopTof — Buy Now → Checkout (direct)
 * Flow: Product Page → Buy Now → /cart/add → /checkout
 * Adds item to cart via AJAX then redirects directly to Shopify checkout.
 */
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.ali-buy-now');
    if(!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    if(!variantId) { window.location.href = '/checkout'; return; }

    // Read the real quantity from the on-page quantity selector (defaults to 1 if not found)
    var qtyInput = document.getElementById('st-qty-input');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    var originalHTML = btn.innerHTML;
    btn.innerHTML = '⏳ Processing…';
    btn.style.pointerEvents = 'none';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
    })
    .then(function(r){ return r.json(); })
    .then(function(data){
      if(data.status && data.status !== 200){
        btn.innerHTML = originalHTML;
        btn.style.pointerEvents = '';
        return;
      }
      /* Redirect directly to Shopify checkout */
      window.location.href = '/checkout';
    })
    .catch(function(){
      /* Fallback: still go to checkout */
      window.location.href = '/checkout';
    });
  });
})();
